import { createCrudPage } from './factories/crud-page.js';
import { bannersCards } from './banners-cards/banners-cards.js';
import { bannersConfig } from './banners-config.js';
import { createRestCardGridLayoutStore } from '../adapters/rest-card-grid-layout-store.js';

// Grid mode: the filter + table become a card (`__table`) alongside the overview
// + by-type cards in ONE reorder/resize/hide card-grid. Uses a SEPARATE layout
// endpoint so it doesn't fight the strip-mode banners page's persisted layout.
export default createCrudPage(bannersConfig({
  mode: 'grid',
  cards: bannersCards,
  layoutStoreFactory: (services) => createRestCardGridLayoutStore({
    apiClient: services.apiClient,
    endpoint: '/banners/cards-grid-layout',
    logger: services.logger,
  }),
}));
